import { MenuItem, Tab, TabPane } from "semantic-ui-react";
import {
  NewPageComponent,
  NewPageComponentProps,
} from "../page/NewPageComponent";
import { Tooltip } from "../../tooltip";

export const SecondaryNavigationTabMenuComponent = (props: {
  props: SecondaryNavigationTabMenuComponentProps;
}) => {
  const panes = props.props.menuItems.map((item) => {
    return {
      menuItem: (
        <MenuItem>
          {item.name}
          <Tooltip name={item.name} message={item.tooltip} />
        </MenuItem>
      ),
      render: () => (
        <TabPane attached={false}>
          <NewPageComponent props={item.pageComponent} />
        </TabPane>
      ),
    };
  });
  return (
    <div>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
};

export type SecondaryNavigationTabMenuComponentProps = {
  menuItems: {
    name: string;
    tooltip: string;
    pageComponent: NewPageComponentProps;
  }[];
};
